export default {
    data() {
        return {
          rechargeList: [
            {
              "qrcode": "/upload/file/rechargeQrcode/DOGE.png?t=1",
              "icon": "DOGE",
              "username": "****3833",
              "money": 2787,
              "type": 1,
              "time": "04:40"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/BTC.png",
              "icon": "BTC",
              "username": "****2301",
              "money": 443,
              "type": 1,
              "time": "04:33"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/DOGE.png?t=1",
              "icon": "DOGE",
              "username": "****9008",
              "money": 2601,
              "type": 1,
              "time": "03:46"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/BCH.png",
              "icon": "BCH",
              "username": "****7014",
              "money": 95615,
              "type": 1,
              "time": "04:17"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/XRP.png?t=1",
              "icon": "XRP",
              "username": "****4754",
              "money": 1280,
              "type": 1,
              "time": "05:14"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/USDT-TRC20.png",
              "icon": "USDT-TRC20",
              "username": "****8593",
              "money": 2310,
              "type": 1,
              "time": "05:33"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/USDC.png",
              "icon": "USDC",
              "username": "****4341",
              "money": 3933,
              "type": 1,
              "time": "03:45"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/BTC.png",
              "icon": "BTC",
              "username": "****5791",
              "money": 606,
              "type": 1,
              "time": "03:47"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/LTC.png",
              "icon": "LTC",
              "username": "****4686",
              "money": 37710,
              "type": 1,
              "time": "04:30"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/SOL.png?t=1",
              "icon": "SOL",
              "username": "****3035",
              "money": 4342,
              "type": 1,
              "time": "05:33"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/BCH.png",
              "icon": "BCH",
              "username": "****8097",
              "money": 1505,
              "type": 1,
              "time": "03:45"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/BCH.png",
              "icon": "BCH",
              "username": "****4620",
              "money": 2371,
              "type": 1,
              "time": "04:38"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/USDC.png",
              "icon": "USDC",
              "username": "****5292",
              "money": 545,
              "type": 1,
              "time": "03:58"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/USDC.png",
              "icon": "USDC",
              "username": "****6524",
              "money": 54397,
              "type": 1,
              "time": "04:17"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/BCH.png",
              "icon": "BCH",
              "username": "****5601",
              "money": 1829,
              "type": 1,
              "time": "04:03"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/BTC.png",
              "icon": "BTC",
              "username": "****1737",
              "money": 2303,
              "type": 1,
              "time": "04:21"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/USDC.png",
              "icon": "USDC",
              "username": "****2489",
              "money": 3376,
              "type": 1,
              "time": "04:34"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/BCH.png",
              "icon": "BCH",
              "username": "****3740",
              "money": 3077,
              "type": 1,
              "time": "04:45"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/USDC.png",
              "icon": "USDC",
              "username": "****7270",
              "money": 98291,
              "type": 1,
              "time": "05:03"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/USDT-TRC20.png",
              "icon": "USDT-TRC20",
              "username": "****1676",
              "money": 3420,
              "type": 1,
              "time": "04:31"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/DOGE.png?t=1",
              "icon": "DOGE",
              "username": "****4547",
              "money": 4348,
              "type": 1,
              "time": "04:39"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/BCH.png",
              "icon": "BCH",
              "username": "****5871",
              "money": 2939,
              "type": 1,
              "time": "04:16"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/USDT-TRC20.png",
              "icon": "USDT-TRC20",
              "username": "****6384",
              "money": 1801,
              "type": 1,
              "time": "05:25"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/LTC.png",
              "icon": "LTC",
              "username": "****5621",
              "money": 72853,
              "type": 1,
              "time": "03:47"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/USDT-TRC20.png",
              "icon": "USDT-TRC20",
              "username": "****2669",
              "money": 916,
              "type": 1,
              "time": "05:28"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/DOGE.png?t=1",
              "icon": "DOGE",
              "username": "****3093",
              "money": 3461,
              "type": 1,
              "time": "05:18"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/BCH.png",
              "icon": "BCH",
              "username": "****3716",
              "money": 2237,
              "type": 1,
              "time": "04:47"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/LTC.png",
              "icon": "LTC",
              "username": "****5142",
              "money": 3129,
              "type": 1,
              "time": "04:49"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/ETH.png",
              "icon": "ETH",
              "username": "****7883",
              "money": 63575,
              "type": 1,
              "time": "03:49"
            },
            {
              "qrcode": "/upload/file/rechargeQrcode/DOGE.png?t=1",
              "icon": "DOGE",
              "username": "****2047",
              "money": 3699,
              "type": 1,
              "time": "04:57"
            }
          ],
            userList: [
              {
                "username": "****.brown@yahoo.com",
                "time": "05:29"
              },
              {
                "username": "****williams98@yahoo.com",
                "time": "04:35"
              },
              {
                "username": "****.davis@icloud.com",
                "time": "05:27"
              },
              {
                "username": "****.miller49@outlook.com",
                "time": "04:14"
              },
              {
                "username": "****_smith40@icloud.com",
                "time": "03:46"
              },
              {
                "username": "****.williams@outlook.com",
                "time": "03:57"
              },
              {
                "username": "****.jones38@outlook.com",
                "time": "05:18"
              },
              {
                "username": "****_johnson@gmail.com",
                "time": "05:14"
              },
              {
                "username": "****jones74@outlook.com",
                "time": "03:41"
              },
              {
                "username": "****_miller@outlook.com",
                "time": "05:27"
              },
              {
                "username": "****.smith44@hotmail.com",
                "time": "04:24"
              },
              {
                "username": "****.miller57@icloud.com",
                "time": "04:57"
              },
              {
                "username": "****.davis@gmail.com",
                "time": "03:43"
              },
              {
                "username": "****_smith@hotmail.com",
                "time": "05:32"
              },
              {
                "username": "****williams77@icloud.com",
                "time": "05:30"
              },
              {
                "username": "****_davis9@gmail.com",
                "time": "03:53"
              },
              {
                "username": "****.johnson91@gmail.com",
                "time": "04:22"
              },
              {
                "username": "****.johnson@gmail.com",
                "time": "03:45"
              },
              {
                "username": "****_jones12@outlook.com",
                "time": "05:28"
              },
              {
                "username": "****_brown48@icloud.com",
                "time": "05:20"
              },
              {
                "username": "****.jones@icloud.com",
                "time": "05:26"
              },
              {
                "username": "****.brown@hotmail.com",
                "time": "04:30"
              },
              {
                "username": "****_jones71@gmail.com",
                "time": "05:12"
              },
              {
                "username": "****.jones23@yahoo.com",
                "time": "03:53"
              },
              {
                "username": "****_jones58@icloud.com",
                "time": "04:04"
              },
              {
                "username": "****.jones@outlook.com",
                "time": "03:50"
              },
              {
                "username": "****_brown@icloud.com",
                "time": "03:53"
              },
              {
                "username": "****_smith@icloud.com",
                "time": "04:10"
              },
              {
                "username": "****.johnson77@icloud.com",
                "time": "05:28"
              },
              {
                "username": "****davis60@icloud.com",
                "time": "04:26"
              }
            ],
            withdrawList: [
                {
                  "qrcode": "/upload/file/rechargeQrcode/ETH.png",
                  "icon": "ETH",
                  "username": "****4898",
                  "money": 3300,
                  "type": 2,
                  "time": "05:29"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDC.png",
                  "icon": "USDC",
                  "username": "****6946",
                  "money": 4848,
                  "type": 2,
                  "time": "03:46"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/LTC.png",
                  "icon": "LTC",
                  "username": "****8578",
                  "money": 1688,
                  "type": 2,
                  "time": "05:00"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/BCH.png",
                  "icon": "BCH",
                  "username": "****5187",
                  "money": 33303,
                  "type": 2,
                  "time": "05:33"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/XRP.png?t=1",
                  "icon": "XRP",
                  "username": "****7519",
                  "money": 457,
                  "type": 2,
                  "time": "05:34"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDT-TRC20.png",
                  "icon": "USDT-TRC20",
                  "username": "****1517",
                  "money": 4930,
                  "type": 2,
                  "time": "04:36"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/LTC.png",
                  "icon": "LTC",
                  "username": "****6538",
                  "money": 426,
                  "type": 2,
                  "time": "05:15"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDC.png",
                  "icon": "USDC",
                  "username": "****8339",
                  "money": 3919,
                  "type": 2,
                  "time": "04:59"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDC.png",
                  "icon": "USDC",
                  "username": "****3007",
                  "money": 55299,
                  "type": 2,
                  "time": "04:39"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDC.png",
                  "icon": "USDC",
                  "username": "****4244",
                  "money": 3147,
                  "type": 2,
                  "time": "04:29"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDC.png",
                  "icon": "USDC",
                  "username": "****5619",
                  "money": 3664,
                  "type": 2,
                  "time": "05:33"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDC.png",
                  "icon": "USDC",
                  "username": "****5631",
                  "money": 3882,
                  "type": 2,
                  "time": "03:59"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/ETH.png",
                  "icon": "ETH",
                  "username": "****6981",
                  "money": 2390,
                  "type": 2,
                  "time": "04:43"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/LTC.png",
                  "icon": "LTC",
                  "username": "****3317",
                  "money": 80237,
                  "type": 2,
                  "time": "05:16"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/SOL.png?t=1",
                  "icon": "SOL",
                  "username": "****4394",
                  "money": 1428,
                  "type": 2,
                  "time": "04:01"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/BTC.png",
                  "icon": "BTC",
                  "username": "****1789",
                  "money": 1145,
                  "type": 2,
                  "time": "03:53"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/BCH.png",
                  "icon": "BCH",
                  "username": "****1429",
                  "money": 3867,
                  "type": 2,
                  "time": "04:15"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/BTC.png",
                  "icon": "BTC",
                  "username": "****6560",
                  "money": 936,
                  "type": 2,
                  "time": "04:18"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/LTC.png",
                  "icon": "LTC",
                  "username": "****7949",
                  "money": 72130,
                  "type": 2,
                  "time": "03:49"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/DOGE.png?t=1",
                  "icon": "DOGE",
                  "username": "****7651",
                  "money": 4434,
                  "type": 2,
                  "time": "04:46"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/ETH.png",
                  "icon": "ETH",
                  "username": "****1573",
                  "money": 3555,
                  "type": 2,
                  "time": "03:51"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/ETH.png",
                  "icon": "ETH",
                  "username": "****9640",
                  "money": 3737,
                  "type": 2,
                  "time": "04:41"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDT-TRC20.png",
                  "icon": "USDT-TRC20",
                  "username": "****7319",
                  "money": 1556,
                  "type": 2,
                  "time": "05:19"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/LTC.png",
                  "icon": "LTC",
                  "username": "****8107",
                  "money": 26772,
                  "type": 2,
                  "time": "05:16"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDT-TRC20.png",
                  "icon": "USDT-TRC20",
                  "username": "****5827",
                  "money": 4608,
                  "type": 2,
                  "time": "05:04"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/LTC.png",
                  "icon": "LTC",
                  "username": "****8898",
                  "money": 3274,
                  "type": 2,
                  "time": "04:06"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDT-TRC20.png",
                  "icon": "USDT-TRC20",
                  "username": "****2597",
                  "money": 1888,
                  "type": 2,
                  "time": "05:14"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/USDT-TRC20.png",
                  "icon": "USDT-TRC20",
                  "username": "****4259",
                  "money": 3613,
                  "type": 2,
                  "time": "04:57"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/LTC.png",
                  "icon": "LTC",
                  "username": "****8433",
                  "money": 16877,
                  "type": 2,
                  "time": "04:34"
                },
                {
                  "qrcode": "/upload/file/rechargeQrcode/ETH.png",
                  "icon": "ETH",
                  "username": "****2190",
                  "money": 4713,
                  "type": 2,
                  "time": "04:41"
                }
              ]
        }
    },
}